<template>
	<div>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane :label="this.$t('file.adminfile.title')" name="first"><AdminFile></AdminFile></el-tab-pane>
			<el-tab-pane :label="this.$t('file.appfile.title')" name="second"><APPFile></APPFile></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import AdminFile from '../../components/pages/fileManage/AdminFile';
	import APPFile from '../../components/pages/fileManage/APPFile';

	export default {
		name: 'File',
		components: {
			AdminFile,
			// UserFile,
			APPFile
		},
		data() {
			return {
				activeName: 'first'
			};
		},
		methods: {

		},
	};
</script>

<style scoped lang="scss">

</style>
